import { useEffect, useMemo, useState } from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { generatePath, Link } from 'react-router'
import { useMediaQuery } from 'usehooks-ts'

import { useModalStore } from '@features/modal'
import { useAddressStore } from '@features/shipping-methods'

import { URL_PAGE_CATALOG_1ST_LVL } from '@shared/contants'
import { useCategoriesBranchQuery } from '@shared/generated'
import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'


function ChildrenCategoriesLoading () {
  return (
    <SkeletonTheme>
      {Array.from({
        length: 12,
      }).map((_, index) => {
        return (
          <Skeleton
            width={'100%'}
            height={20}
            style={{
              borderRadius: 6,
            }}
            key={index}
          />
        )
      })}
    </SkeletonTheme>
  )
}

function CategoriesLoading () {
  return (
    <SkeletonTheme>
      <Skeleton
        count={10}
        width={170}
        height={30}
        style={{
          borderRadius: 6,
          marginBottom: 16,
        }}
      />
    </SkeletonTheme>
  )
}

export default function ModalCategories () {
  const isTablet = useMediaQuery('(max-width: 1179px)')
  const { closeModal } = useModalStore()
  const { shopId } = useAddressStore()
  const { data: categoriesBranch, loading: loadingCategoriesBranch } =
    useCategoriesBranchQuery({
      variables: {
        shopId,
      },
    })

  const [ activeCategoryId, setActiveCategoryId ] = useState<string>()

  // TODO: при первой загрузке делаем первую категорию активной
  useEffect(() => {
    const categories = categoriesBranch?.categoriesBranch

    if (!activeCategoryId && categories) {
      setActiveCategoryId(categories[0]?.id as string)
    }
  }, [ categoriesBranch ])

  useEffect(() => {
    if (isTablet) {
      closeModal('categories')
    }
  }, [ isTablet ])

  const ACTIVE_CATEGORY_SLUG = useMemo(() => {
    const categories = categoriesBranch?.categoriesBranch
    if (activeCategoryId && categories) {
      const category = categories.find(
        (item) => item && item.id === activeCategoryId,
      )
      return category?.slug
    }
  }, [ activeCategoryId, categoriesBranch?.categoriesBranch ])

  const CHILDREN_CATEGORIES = useMemo(() => {
    return (
      categoriesBranch?.categoriesBranch?.find((c) => c?.id == activeCategoryId)
        ?.childrens || []
    )
  }, [ activeCategoryId, categoriesBranch?.categoriesBranch ])

  return (
    <div className={styles.root}>
      <div className={styles.root__left}>
        {loadingCategoriesBranch && <CategoriesLoading />}
        {!loadingCategoriesBranch &&
          categoriesBranch?.categoriesBranch?.map((item) => {
            return (
              <Link
                key={item?.id}
                className={cn(styles.root__link, {
                  [styles._active]: item?.id == activeCategoryId,
                })}
                to={generatePath(URL_PAGE_CATALOG_1ST_LVL, {
                  categorySlug: item?.slug as string
                })}
                onClick={() => closeModal('categories')}
                onMouseEnter={() => {
                  setActiveCategoryId(item?.id as string)
                }}
              >
                <img
                  className={styles.root__icon}
                  src={item?.icon?.url as string}
                  alt=""
                  loading="lazy"
                  fetchPriority="low"
                />
                {item?.name}
              </Link>
            )
          })}
      </div>

      {activeCategoryId && (
        <div className={styles.root__right}>
          {loadingCategoriesBranch && <ChildrenCategoriesLoading />}

          {!loadingCategoriesBranch &&
            CHILDREN_CATEGORIES.map((item, index) => {
              return (
                <Link
                  className={styles.root__children}
                  to={`/catalog/${ACTIVE_CATEGORY_SLUG}/${item?.slug as string}?category_id=${item?.id}`}
                  onClick={() => closeModal('categories')}
                  key={`${item?.id ?? item?.slug ?? index}`}
                >
                  {item?.name}
                </Link>
              )
            })}
        </div>
      )}
    </div>
  )
}
